import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { StateService } from '../../services/state.service'
import { IonButtons, IonHeader, IonToolbar, IonTitle, IonMenuButton, IonContent } from '@ionic/angular'
import { InjectHTMLDirective } from '../../directives/inject-html.directive'
import { MOBILE_APP_PAGE_SLUG } from '../../models/page'

@Component({
  selector: 'app-extra',
  templateUrl: './extra-page.component.html',
  styleUrl: './extra-page.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonButtons, IonHeader, IonToolbar, IonTitle, IonMenuButton, IonContent, InjectHTMLDirective],
})
export class ExtraPageComponent {
  private route = inject(ActivatedRoute)
  private stateService = inject(StateService)
  private router = inject(Router)

  title: string | undefined = undefined
  content: string = ''
  icon: string | undefined = undefined

  constructor() {
    this.setPageContent()
  }

  setPageContent() {
    const slug = this.route.snapshot.paramMap.get('slug') || ''
    if (slug === MOBILE_APP_PAGE_SLUG) {
      this.router.navigate(['download'])
      return
    }
    const page = this.stateService.getExtraPage(slug)
    if (!page) {
      this.router.navigate([''])
      return
    }
    const { menutitle, content, icon } = page
    this.title = menutitle
    this.content = content
    this.icon = icon
  }
}
